// Removes the search parameter from a serialized "a=1&b=2" query string.
// Used when a view is left, so a stale search term is not reapplied on return.
export function stripSearchParam(query, key = 'search') {
  return (query || '')
    .split('&')
    .filter(part => !part.startsWith(`${key}=`))
    .join('&');
}
